// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__1DXcv","arrow":"page_arrow__2lFIv","pageContent":"page_pageContent__22bdl","closeButt":"page_closeButt__2acQ4"};